import React, {forwardRef} from "react";
import Tooltip from "./Tooltip";

const IconButton = forwardRef((props, ref) => {
    const {id, icon, label, disabled = false, badge = false, onPrimary, className, title, tooltip, tooltipClassName, placement = 'right', tabIndex = 0, ...other} = props;
    const useTag = '<use xlink:href="#' + icon + '" />';

    if (tooltip) return (
        <Tooltip role={'none'} aria-label={null} title={(tooltip ? tooltip : '')} className={(tooltipClassName ? ' ' + tooltipClassName : '')}
                 placement={placement} enterNextDelay={100} disableInteractive>
            <span>
                <button
                    id={id}
                    ref={ref}
                    aria-label={tooltip}
                    className={'ch-icon-btn' + (onPrimary ? ' ch-icon-btn-on-primary' : '') + (disabled ? ' ch-icon-btn-disabled' : '') + (className ? ' ' + className : '')}
                    style={disabled ? {pointerEvents: 'none'} : {}}
                    tabIndex={tabIndex}
                    disabled={disabled}
                    {...other}
                >
                    {icon !== undefined &&
                        <svg className={'ch-icon-sm'} dangerouslySetInnerHTML={{__html: useTag}} width={32} height={32}
                             viewBox='0 0 128 128'/>
                    }
                    {badge !== undefined && badge === true &&
                        <div className='ch-icon-badge'></div>
                    }
                    {badge !== undefined && typeof badge === 'string' &&
                        <div className='ch-icon-badge-lg'>{badge}</div>
                    }
                    {props.children}
                </button>
            </span>
        </Tooltip>
    )
    return (
        <button
            id={id}
            ref={ref}
            aria-label={label}
            className={'ch-icon-btn' + (onPrimary ? ' ch-icon-btn-on-primary' : '') + (disabled ? ' ch-icon-btn-disabled' : '') + (className ? ' ' + className : '')}
            tabIndex={tabIndex}
            disabled={disabled} {...other}
        >
            {icon !== undefined &&
                <svg className={'ch-icon-sm'} dangerouslySetInnerHTML={{__html: useTag}} width={32} height={32}
                     viewBox='0 0 128 128'/>
            }
            {badge !== undefined && badge === true &&
                <div className='ch-icon-badge'></div>
            }
            {badge !== undefined && typeof badge === 'string' &&
                <div className='ch-icon-badge-lg'>{badge}</div>
            }
            {props.children}
        </button>
    )
});

export default IconButton;